<template>
	<div class="container group-page">
		<section class="page-hero">
			<div>
				<span class="eyebrow">LINK CENTER</span>
				<h2>域名分组</h2>
				<p>先创建分组，再在域名管理和目标域名地址中直接选择，无需填写编号。</p>
			</div>
			<el-button type="primary" icon="el-icon-plus" @click="open()">新建分组</el-button>
		</section>
		<el-card shadow="never" class="group-card">
			<div class="table-caption">
				<span>分组列表</span><small>共 {{ list.length }} 个域名分组</small>
			</div>
			<el-table v-loading="loading" :data="list" row-key="id" class="group-table" empty-text="暂无分组，先创建一个分组开始使用">
				<el-table-column label="分组名称" prop="name" min-width="260"
					><template slot-scope="{ row }"
						><div class="group-name">
							<span class="group-mark">{{ row.name.slice(0, 1) }}</span
							>{{ row.name }}
						</div></template
					></el-table-column
				>
				<el-table-column label="国家限制" min-width="180"
					><template slot-scope="{ row }"
						><span class="country-cell">{{ row.countries || '不限国家/地区' }}</span></template
					></el-table-column
				>
				<el-table-column label="状态" width="174" align="center"
					><template slot-scope="{ row }"
						><el-switch v-model="row.state" :active-value="2" :inactive-value="1" @change="updateStatus(row, $event)" /><el-tag size="mini" :type="row.state === 2 ? 'success' : 'info'">{{ row.state === 2 ? '启用' : '停用' }}</el-tag></template
					></el-table-column
				>
				<el-table-column label="创建时间" width="182"
					><template slot-scope="{ row }"
						><div class="time-cell"><i class="el-icon-time" />{{ formatTime(row.created_at) }}</div></template
					></el-table-column
				>
				<el-table-column label="最后更新" width="182"
					><template slot-scope="{ row }"
						><div class="time-cell"><i class="el-icon-refresh" />{{ formatTime(row.updated_at) }}</div></template
					></el-table-column
				>
				<el-table-column label="操作" width="148" align="center"
					><template slot-scope="{ row }"><el-button type="text" @click="open(row)">编辑</el-button><el-button type="text" class="danger-button" @click="remove(row)">删除</el-button></template></el-table-column
				>
			</el-table>
		</el-card>
		<el-dialog :title="form.id ? '编辑分组' : '新建分组'" :visible.sync="visible" width="460px" custom-class="group-dialog">
			<div class="dialog-tip"><i class="el-icon-collection-tag" /> App 入口域名会轮询同分组内的其他域名；后台域名再按短链权重跳转。</div>
			<el-form ref="form" :model="form" :rules="rules" label-width="86px"
				><el-form-item label="分组名称" prop="name"><el-input v-model.trim="form.name" maxlength="64" show-word-limit placeholder="例如：夏季活动"/></el-form-item
				><el-form-item label="状态"
					><el-radio-group v-model="form.state"><el-radio :label="2">启用</el-radio><el-radio :label="1">停用</el-radio></el-radio-group></el-form-item
				><el-form-item label="国家白名单"
					><el-select v-model="form.country_list" multiple filterable clearable collapse-tags placeholder="留空表示不限制" style="width:100%"><el-option v-for="item in countries" :key="item.code" :label="item.name" :value="item.name"/></el-select>
					<p class="field-help block">仅允许所选国家或地区访问此分组。</p></el-form-item
				></el-form
			>
			<div slot="footer"><el-button @click="visible = false">取消</el-button><el-button type="primary" @click="save(form)">保存分组</el-button></div>
		</el-dialog>
		<el-dialog title="删除分组" :visible.sync="removeVisible" width="440px" custom-class="group-dialog"
			><div class="dialog-tip"><i class="el-icon-warning-outline" /> 未分配内容的分组可直接删除；已有域名或短链时，请选择接收分组后删除。</div>
			<el-form label-width="90px"
				><el-form-item label="重新分配至"
					><el-select v-model="targetGroupId" clearable placeholder="未分配内容可留空" style="width:100%"><el-option v-for="item in reassignGroups" :key="item.id" :label="item.name" :value="item.id"/></el-select></el-form-item
			></el-form>
			<div slot="footer"><el-button @click="removeVisible = false">取消</el-button><el-button type="danger" @click="confirmRemove">确认删除</el-button></div></el-dialog
		>
	</div>
</template>
<script>
	export default {
		name: 'DomainGroupManager',
		data() {
			return { loading: false, list: [], countries: [], visible: false, removeVisible: false, removingGroup: null, targetGroupId: '', form: {}, rules: { name: [{ required: true, message: '请输入分组名称', trigger: 'blur' }] } };
		},
		computed: {
			reassignGroups() {
				return this.list.filter((item) => this.removingGroup && item.id !== this.removingGroup.id && item.state === 2);
			}
		},
		created() {
			this.load();
			this.request.get('/system', { params: { key: 'COUNTRY' } }).then((data) => {
				this.countries = data.country || [];
			});
		},
		activated() {
			this.load();
		},
		methods: {
			formatTime(value) {
				if (!value) return '--';
				const date = new Date(value);
				if (Number.isNaN(date.getTime())) return value;
				const pad = (number) => String(number).padStart(2, '0');
				return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
			},
			load() {
				this.loading = true;
				this.request
					.get('/domain-group')
					.then((data) => {
						this.list = data.list || [];
					})
					.finally(() => {
						this.loading = false;
					});
			},
			open(row) {
				this.form = Object.assign({ name: '', state: 2, countries: '', country_list: [] }, row || {});
				this.form.country_list = this.form.countries ? this.form.countries.split(',').filter(Boolean) : [];
				this.visible = true;
				this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
			},
			updateStatus(row, state) {
				this.request
					.post('/domain-group-edit', { id: row.id, state })
					.then(() => {
						this.$message.success('状态已更新');
					})
					.catch(() => {
						row.state = state === 2 ? 1 : 2;
					});
			},
			save() {
				this.$refs.form.validate((valid) => {
					if (!valid) return;
					const path = this.form.id ? '/domain-group-edit' : '/domain-group-add';
					const payload = { name: this.form.name, state: this.form.state, countries: this.form.country_list.join(',') };
					if (this.form.id) payload.id = this.form.id;
					this.request.post(path, payload).then(() => {
						this.$message.success('分组已保存');
						this.visible = false;
						this.load();
					});
				});
			},
			remove(row) {
				this.removingGroup = row;
				this.targetGroupId = '';
				this.removeVisible = true;
			},
			confirmRemove() {
				this.request.post('/domain-group-remove', { id: this.removingGroup.id, target_group_id: this.targetGroupId }).then(() => {
					this.$message.success('分组已删除');
					this.removeVisible = false;
					this.load();
				});
			}
		}
	};
</script>
<style scoped>
	.group-page {
		padding-top: 18px;
	}
	.page-hero {
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		height: 96px;
		margin-bottom: 18px;
		padding: 14px 24px;
		color: #fff;
		border-radius: 14px;
		background: linear-gradient(120deg, #264b73, #4d86a9);
		box-shadow: 0 10px 24px rgba(38, 75, 115, 0.16);
	}
	.eyebrow {
		color: rgba(255, 255, 255, 0.68);
		letter-spacing: 1.4px;
		font-size: 10px;
	}
	.page-hero h2 {
		margin: 2px 0 4px;
		font-size: 20px;
	}
	.page-hero p {
		margin: 0;
		color: rgba(255, 255, 255, 0.82);
		font-size: 12px;
	}
	.group-card {
		border: 0;
		border-radius: 12px;
		box-shadow: 0 5px 20px rgba(30, 54, 80, 0.08);
	}
	.table-caption {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		padding: 2px 2px 16px;
		color: #30465f;
		font-size: 15px;
		font-weight: 600;
	}
	.table-caption small {
		color: #93a0ae;
		font-size: 12px;
		font-weight: 400;
	}
	.group-table {
		overflow: hidden;
		border: 1px solid #e8eff5;
		border-radius: 10px;
	}
	.group-table::v-deep th.el-table__cell {
		padding: 12px 0;
		color: #607287;
		background: #f7f9fc;
	}
	.group-table::v-deep td.el-table__cell {
		padding: 15px 0;
	}
	.group-name {
		display: flex;
		align-items: center;
		gap: 10px;
		color: #34445b;
		font-weight: 600;
	}
	.group-mark {
		display: grid;
		width: 28px;
		height: 28px;
		place-items: center;
		color: #3c7598;
		border-radius: 8px;
		background: #e8f2f8;
	}
	.el-tag {
		margin-left: 8px;
	}
	.time-cell {
		color: #718399;
		font-size: 13px;
		white-space: nowrap;
	}
	.time-cell i {
		margin-right: 6px;
		color: #95a6b5;
	}
	.danger-button {
		color: #d96868;
	}
	.dialog-tip {
		margin: 0 0 20px;
		padding: 11px 13px;
		color: #567188;
		border-radius: 8px;
		background: #f2f7fb;
		font-size: 13px;
	}
	.dialog-tip i {
		color: #4781a4;
		margin-right: 6px;
	}
	.country-cell {
		color: #61788c;
		font-size: 13px;
	}
	.field-help {
		margin-left: 8px;
		color: #8c99a8;
		font-size: 12px;
	}
	.field-help.block {
		margin: 6px 0 0;
	}
	@media (max-width: 760px) {
		.page-hero {
			align-items: flex-start;
			height: auto;
			padding: 20px;
		}
		.page-hero > .el-button {
			flex: none;
		}
	}
</style>
